/**
 * Ordenacao das faixas de uma meta progressiva ao reabrir para edicao.
 *
 * As linhas chegam da API na ordem do banco, que nao e a ordem crescente de
 * qtde_de. O form de faixas valida cada faixa contra a ANTERIOR NO ARRAY
 * (calculoMixin.getFaixaOrdemErroItem / getFaixaOrdemErroIndividualItem:
 * "Minimo deve ser > maximo da faixa anterior"), entao a posicao no array e
 * significativa: uma meta gravada correta, reaberta fora de ordem, acusa erro
 * numa faixa que nao tem nada de errado.
 *
 * Usado pelos dois caminhos de reconstrucao de editarMeta — o coletivo, direto
 * no ModalCadastroMeta, e o individual, em metaIndividualLeituraUtils.
 */

/**
 * Ordena as faixas por minimo crescente, sem mutar o array recebido.
 * Empate no minimo desempata pelo maximo, so para a ordem ser estavel.
 *
 * @param {Array<{minimo:*, maximo:*, bonus:*}>} faixas
 * @returns {Array<{minimo:*, maximo:*, bonus:*}>}
 */
export function ordenarFaixas(faixas) {
  return [...(faixas || [])].sort(
    (a, b) => parseFloat(a.minimo) - parseFloat(b.minimo) || parseFloat(a.maximo) - parseFloat(b.maximo)
  );
}
